<template lang="pug">
	Popup(v-if="newSubscription.visible", :popupVisible.sync="newSubscription.visible", :width="960", :height="640")
		.company-subscriptions
			template(v-if="newSubscription.step === 'initial'")
				ListView(
					name="subscriptionPlans"
					:columnHidingEnabled="false"
					ref="subscriptionPlans"
					initialView="cards"
					:hideViewsSelection="true"
					:getTotal="(r) => r && r.TotalNumberOfRecords || 0"
					:getItems="r => r.Results"
					:getData="$Data.getSubscriptionPlans"
					@data-loaded="onDataLoaded"
				)
					.flex-col.space-large.align-center.center(slot="left-actions")
						.font-big.padding {{$tCaption('Select a subscription')}}
					template(v-slot:card="{ data }")
						.flex-col.subscription-card.clickable.click-effect(
							@click="onSubscriptionSelected(data)",
							:class="{ selected: newSubscription.selectedSubscription && newSubscription.selectedSubscription.Oid === data.Oid }"
						)
							.flex-col(:class="{ 'disabled-controls': data.HasNoAvailableStations }")
								.flex-row.justify.align-center
									.subscription-name {{data.Name}}
									.billing-cycle.flex-row.align-center.space
										i.fas.fa-calendar-alt
										span {{getArrVal(billingCycle, data.BillingCycle)}}
								.flex-col.space-large.subscription-info
									.flex-col.products
										.product.flex-row.justify(v-for="product in (data.Products || [])")
											.product-name {{product.Name}}
											.product-prices.flex-row.space
												.product-price.flex-row(v-for="(price, i) in product.Rates.filter(r => r.CurrencyCode === data.CurrencyCode)")
													span {{$currencySign(price.CurrencyCode)}}
													span {{$formatNumber(price.Price, 2)}}
									.flex-row.justify
										.flex-col
											.flex-row.space.align-center
												.font-small.upper.grey {{$tCaption('Payment days')}}:
												span {{data.PaymentDays}}
											.flex-row.align-center.space
												.font-small.upper.grey {{$tCaption('Subtotal')}}:
												span {{$currencySign(data.CurrencyCode)}}{{$formatNumber(data.Subtotal, 2)}}
										.flex-col.space-large
											.flex-col
												.flex-row.space.align-center.space
													.font-small.upper.grey {{$tCaption('Tax percent')}}:
													span {{data.TaxPercent}}%
												.flex-row.align-center.space
													.font-small.upper.grey {{$tCaption('Tax amount')}}:
													span {{$currencySign(data.CurrencyCode)}}{{$formatNumber(data.TaxAmount, 2)}}
									.flex-row.justify
										.flex-row.space.align-center.total.justify
											.font-small.upper.grey.total-caption {{$tCaption('Total')}}
											.flex-row.align-center
												.total-currency {{$currencySign(data.CurrencyCode)}}
												.total-number {{$formatNumber(data.Total, 2)}}
									.flex-row.flex-1.align-center.space-between
										a.font-tiny(href="https://www.adthos.com/subscriptions", target="_blank", @click.stop)
											DxButton(:text="$tCaption('Details', '@actions')")
										DxButton(:text="$tCaption('Select', '@actions')" type="success")
							.notification(v-if="data.HasNoAvailableStations") {{$tCaption('You do not have available stations for this subscription')}}
			template(v-if="newSubscription.step === 'payment'")
				.flex-col.space
					.font-big {{$tCaption('Please, choose a payment method')}}
					.flex-col.space-large
						.flex-row.space-large.center.align-center.payment-types
							.payment-type.clickable.click-effect(v-for="payment in billingPaymentType.filter(f => f.id !== 0 || !!newSubscription.selectedSubscription.IsSupportAutomatic)",
								:class="{ selected: newSubscription.selectedPayment && newSubscription.selectedPayment.id === payment.id }"
								@click="newSubscription.selectedPayment = payment")
								.flex-col.space.align-center
									i.payment-icon(:class="[payment.icon]")
									span {{payment.name}}
						.flex-row
							.flex-col.promo-code
								.font-small.upper.grey {{$tCaption('I have a promocode')}}
								DxTextBox(
									:value.sync="newSubscription.promoCode",
									:hint="$tCaption('Promocode')",
									:width="125",
									stylingMode="filled"
									:disabled="isLoading"
									value-change-event="keyup"
									@value-changed="promoCodeValueChanged"
								)
								.error-colored(
									v-if="!newSubscription.promoCodeValid"
								) {{ $tCaption('Wrong PromoCode') }}
			template(v-if="newSubscription.step === 'stationSelection'")
				.flex-col.space-large
					.font-big {{$tCaption('Please select your stations for the subscription')}}
					.flex-col.space-large
						ListView(name="stations", selectionMode="multiple", :bottomPagerVisible="false", :pageSize="6", :columnHidingEnabled="false", ref="stations", initialView="table", :hideViewsSelection="true", :getTotal="(r) => r.TotalNumberOfRecords", :getItems="r => r.Results", 
							:getData="(p, i, opts) => $Data.getExternalStations(p, i, { ...(opts || {}), onlyMyStations: true })", :height="410", :columns="[{ dataField: 'Name', caption: $tCaption('Station') }]", @selection="v => newSubscription.stations = v")
			template(v-if="newSubscription.step === 'finalStep'")
				.flex-col.space-large
					.font-big {{$tCaption('Please wait while we are creating your subscription.')}}
					.status {{newSubscription.status}}
					span(v-if="newSubscription.isRedirecting") {{$tCaption('You will be redirected to payment portal in ')}}{{newSubscription.redirectTime}} {{$tCaption('seconds')}}
		.flex-row.space(slot="actions-left")
			DxButton(v-if="newSubscription.step !== 'initial' && newSubscription.step !== 'finalStep'", text="Back", @click="() => nextStep(-1)")
			.flex-row.space.align-center.scroll-more-label(v-if="newSubscription.step === 'initial'")
				.text(v-text="$tCaption('Scroll for more Subscriptions')")
				.icon
					i.fas.fa-angle-double-down
		.flex-row.space-large(slot="actions-right").space-between.flex-1.align-center
			DxButton(:text="$tCaption('Cancel', '@actions')", @click="() => closePopup()")
			DxButton(
				v-if="newSubscription.step !== 'finalStep' && newSubscription.step !== 'payment'",
				:text="$tCaption('Next')",
				@click="() => nextStep(1)",
				type="default",
				:disabled="Object.keys(newSubscription.selectedSubscription).length === 0 || (currentStep && currentStep.canNext && !currentStep.canNext())"
			)
			DxButton(
				v-if="newSubscription.step === 'payment'",
				:text="$tCaption('Subscribe')",
				@click="subscribe",
				type="success",
				:disabled="!newSubscription.selectedSubscription || !newSubscription.selectedPayment || isLoading"
			)
</template>

<script>
	import _ from 'lodash';
	import DxTextBox from 'devextreme-vue/text-box';
	import DxButton from 'devextreme-vue/button';
	import ListView from 'app-core/ListView.vue';
	import Popup from 'app-core/Popup.vue';
	import {getArrVal, activateSubscription} from "app-core/helpers";
	import {BILLING_CYCLES, BILLING_DETAIL_STATUS, BILLING_PAYMENT_TYPE} from "app-core/constants";

	export default {
		translationCategory: 'company.Subscriptions',
		name: "SelectSubscriptionPopup",
		components: {
			Popup, ListView, DxButton, DxTextBox
		},
		props: {
			selectedPlanIndex: {type: Number, required: false}
		},
		watch: {
			'$locale.state.storedTranslations': {
				handler() {
					this.billingCycle = BILLING_CYCLES.toLocale('name', this);
					this.billingPaymentType = BILLING_PAYMENT_TYPE.toLocale('name', this);
				},
				immediate: true,
			},
		},
		data() {
			return {
				isLoading: false,
				getArrVal,
				billingCycle: [],
				billingPaymentType: [],
				newSubscription: {
					visible: false,
					hasAutoPaymentOption: false,
					selectedSubscription: {},
					selectedPayment: null,
					step: 'initial',
					status: null,
					redirectTime: 5,
					isRedirecting: 0,
					stations: [],
					promoCode: null,
					promoCodeValid: true,
				},
				steps: [
					{id: 'initial'},
					{
						id: 'stationSelection',
						canNext: () => this.newSubscription.stations.length > 0,
						hidden: () => this.newSubscription.selectedSubscription && !this.newSubscription.selectedSubscription.StationIsMandatory
					},
					{id: 'payment'}, {id: 'finalStep'}
				],
				currentStep: null,
				subscriptions: {},
			};
		},
		mounted() {
			if (__DEBUG__)
				window.subscription = this;
		},
		methods: {
			onSubscriptionSelected(e) {
				this.newSubscription.selectedSubscription = e.Oid === this.newSubscription.selectedSubscription.Oid ? {} : e;
			},
			onDataLoaded(e) {
				if (this.selectedPlanIndex < e.TotalNumberOfRecords) {
					this.newSubscription.selectedSubscription = e.Results[this.selectedPlanIndex];
				} else {
					console.error('Wrong selectedPlanIndex!')
				}
			},
			show(v) {
				this.newSubscription.visible = false;
				if (v) {
					setImmediate(() => {
						if (this._isDestroyed) return;
						this.newSubscription.stations = [];
						this.currentStep = this.steps[0];
						this.newSubscription.step = 'initial';
						this.newSubscription.selectedPayment = null;
						this.newSubscription.selectedSubscription = {};
						this.newSubscription.visible = true;
					});
				}
			},
			onMenuItemClick(e, data) {
				if (__DEBUG__)
					console.debug('On menu item click', {e, data});
				let subscriptionId = data.Oid;
				switch (e.itemData.id) {
					case 'cancelSubscription':
						this.$confirmMessage({
							title: this.$tCaption('Confirm action', '@actions'),
							text: this.$tCaption('Are you sure you want to cancel subscription?'),
							handler: () => {
								this.$Data
									.getExternalApi(
										'CustomerSubscription/CancelSubscription',
										`subscriptionId=${subscriptionId}`
									)
									.then(r => {
										if (r.Success) {
											this.$notifySuccess(this.$tCaption('Subscription has been successfully canceled'));
											this.$emit('reload-parent-page')
										} else {
											this.$notifyError(r.ErrorMessage);
										}
									});
							}
						});
						break;
					case 'paymentSettings':
						this.isLoading = true;
						this.$Data
							.getExternalApi(
								'CustomerSubscription/GetCustomerPortalUrl',
								`returnUrl=${encodeURIComponent(window.location.href)}`
							)
							.then(r => {
								window.location.href = r;
							})
							.finally(() => this.isLoading = false);
						break;
					case 'initialPayment':
						this.activateSubscription(subscriptionId);
						break;
				}
			},
			promoCodeValueChanged() {
				this.newSubscription.promoCodeValid = true;
			},
			subscribe() {
				this.isLoading = true;

				const subscriptionPlanId = `subscriptionPlanId=${this.newSubscription.selectedSubscription.Oid}`;
				const paymentType = `&paymentType=${this.newSubscription.selectedPayment.id}`;
				const stations = this.newSubscription.stations.length ? `&stationIdsCsv=${this.newSubscription.stations.map(f => f.Oid).join(',')}` : '';
				const promoCode = this.newSubscription.promoCode ? `&promoCode=${this.newSubscription.promoCode}` : '';

				this.$Data
					.getExternalApi(
						'CustomerSubscription/ValidatePromocode',
						`${subscriptionPlanId}${promoCode}`
					)
					.then((r) => {
						this.newSubscription.promoCodeValid = r.Valid;

						if (this.newSubscription.promoCodeValid) {
							this.newSubscription.step = 'finalStep';
							this.newSubscription.status = this.$tCaption('Creating subscription') + '...';

							this.$Data
									.getExternalApi(
										'CustomerSubscription/Subscribe',
										`${subscriptionPlanId}${paymentType}${stations}${promoCode}`
									)
									.then(r => {
										if (r.Success) {
											const successText = this.$tCaption('Your subscription has been successfully created');
											this.$notifySuccess(successText, 3000);
											this.newSubscription.status = successText;

											this.$emit('reload-parent-page')

											if (this.newSubscription.selectedPayment.id === 0) {
												this.newSubscription.redirectTime = 3;
												this.newSubscription.isRedirecting = 1;
												const redirectTimer = () => {
													setTimeout(() => {
														if (this._isDestroyed) return;
														this.newSubscription.redirectTime--;
														if (this.newSubscription.redirectTime > 0)
															redirectTimer()
														else {
															this.newSubscription.status = this.$tCaption('Redirecting') + '...';
															this.activateSubscription(r.Data);
														}
													}, 1000);
												}
												redirectTimer();
											} else {
												this.show(false);
											}
										} else {
											this.$notifyError(r.ErrorMessage, 5000);
											this.show(false);
										}
									}).finally(() => this.isLoading = false);
						} else this.isLoading = false;
					}).catch(() => {
						this.isLoading = false;
					});
			},
			activateSubscription(subscriptionId) {
				this.isLoading = true;
				activateSubscription(subscriptionId).catch(() => {
					this.show(false);
				}).finally(() => {
					this.isLoading = false;
				});
			},
			nextStep(direction) {
				const accessibleSteps = this.steps.filter(f => !f.hidden || !f.hidden());
				this.currentStep = accessibleSteps[_.findIndex(accessibleSteps, v => v.id === this.newSubscription.step) + direction];
				if (this.currentStep)
					this.newSubscription.step = this.currentStep.id;
			},
			closePopup() {
				this.newSubscription.selectedSubscription = {};
				this.show(false);
			}
		},
	}
</script>

<style lang="scss">
	@import "main/themes/generated/variables.base.scss";

	.company-subscriptions {
		margin-top: 0;

		.notification {
			margin-top: 20px;
			padding: 10px;
			background: $base-accent;
			color: $base-bg;
			text-align: center;
		}

		.payment-types {
			height: 280px;
			margin-top: 40px;

			.payment-type {
				padding: 60px;
				background: #f4f4f4;
				border-bottom: 10px solid #f4f4f4;
				transition: 0.3s;
				transform: scale(1);
				user-select: none;
				font-size: 1.4em;
				font-weight: 100;

				&:hover, &.selected {
					border-bottom: 10px solid $base-accent;
					transform: scale(1.1);
				}

				.payment-icon {
					font-size: 2em;
				}
			}
		}

		.subscription-card {
			background: #f6f6f6;
			border: 5px solid #f6f6f6;
			padding: 30px;
			min-height: 320px;
			transition: 0.3s;
			transform: scale(1);
			user-select: none;
			box-sizing: border-box;

			.subscription-name {
				font-size: 2em;
			}

			.billing-cycle {
				background: $base-accent;
				color: $base-bg;
				padding: 10px;
				border-radius: 0px;
			}

			&:hover:not(.selected) {
				transform: scale(1.05);
				background: #eeeeee;
				border: 5px solid #eeeeee;

				.subscription-name {
					color: $base-accent;
				}
			}

			&.selected {
				border: 5px solid $base-accent;

				.subscription-name {
					color: $base-accent;
				}
			}

			.subscription-info {
				margin-top: 20px;
			}

			.product {
				border-bottom: 1px dashed rgba(0, 0, 0, 0.2);
				margin-bottom: 6px;
			}

			.total {
				font-size: 1.8em !important;

				.total-caption {

				}

				.total-currency {
					font-size: 1.2em !important;

				}

				.total-number {
					font-size: 1.2em !important;
					//font-family: monospace;
				}
			}
		}

		.status {
			padding: 4px 12px;
			border-radius: 2px;

			&.initial {
				background: #f7ff9b;
			}

			&.unpaid {
				background: #ff7e7e;
			}

			&.canceled {
				background: #e6e6e6;
			}

			&.active {
				background: #9bffbc;
			}
			
			&.trial {
				background: #9bbbff;
			}
		}

		.click-effect {
			//start click effect
			&:before {
				content: '';
				background-color: rgba(255, 255, 255, 0.4);
				border-radius: 0%;
				display: block;
				position: absolute;
				top: 0;
				right: 0;
				bottom: 0;
				left: 0;
				transform: scale(0.001, 0.001);
			}

			&.selected {
				&:before {
					animation: effect_dylan 1s ease-out;
				}
			}
		}

		.promo-code {
			margin-left: 145px;
		}

		@keyframes effect_dylan {
			50% {
				transform: scale(1.5, 1.5);
				opacity: 0;
			}
			99% {
				transform: scale(0.001, 0.001);
				opacity: 0;
			}
			100% {
				transform: scale(0.001, 0.001);
				opacity: 1;
			}
		}
	}

	.scroll-more-label {
		font-size: 20px;
		margin: 16px;
		color: #f27649;
	}
</style>
